import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getSafe } from './shared/utility';
import { USER_PERMISSIONS } from './shared/const/Routes/statePaths';
import AskEPCUsersRequest from './hoc/PermissionManager/AskEPCUsersRequest';

const EPC_USER = 'USER';
const EPC_ADMIN = 'ADMIN';

const PermissionManager = props => {
  const location = useLocation();
  const userPermissions = useSelector(state =>
    getSafe(USER_PERMISSIONS, state)
  );

  const [isApproved, setIsApproved] = useState(false);
  const [fallback, setFallback] = useState(null);

  useEffect(() => {
    if (!isUserApproval()) {
      setIsApproved(false);
      setFallback(<AskEPCUsersRequest />);
    } else {
      permissionValidation();
    }
  }, [location.pathname, userPermissions]);

  const permissionValidation = () => {
    switch (location.pathname) {
      default:
        setIsApproved(true);
    }
  };

  const isUserApproval = () => {
    return userPermissions[EPC_ADMIN] || userPermissions[EPC_USER];
  };

  return (
    <>
      {!!isApproved && props.children}
      {!isApproved && !!fallback && fallback}
    </>
  );
};

export default PermissionManager;
